module.exports = __webpack_public_path__ + "static/TiemposTextWeb-Semibold-1b9500c61b46c8c732f0519fc26a4d4e.eot";